export const userDirectoryListFunctionName = 'userDirectoryList';
export const userDirectoryGetFunctionName = 'userDirectoryGet';
